import { Provider } from "../models/provider";
import { httpGet } from "./http-client";

const apiUrl = '/api/providers';

export const getProviders = () => httpGet<Provider[]>(apiUrl);
